
import styled from '@emotion/styled';
import AdbIcon from '@mui/icons-material/Adb';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Link as Anchor, Button, Dialog, DialogActions, DialogContent, DialogTitle, ListItem, TextField } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { List, ListItemButton, ListItemText, Paper, MenuList, Divider, Stack, Modal } from '@mui/material'
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close'
import CustomTooltip from './CustomTooltip';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useNavigate } from "react-router-dom";
// bg curves
import lightmodeCurveBg from '../../assets/images/lightmode_curve_bg.png';
import blueBg from '../../assets/images/blue-curve.png'
import greenBg from '../../assets/images/green-curve.png'
import darkBg from '../../assets/images/dark-curve.png'
// -------------
import SwitchThemeMode from '../../assets/styled-components/SwitchThemeMode';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthToken, getuserId, removeAuthToken, removeFCMToken, removeUserLoginStatus } from '../../utility/tokenUtility';
import ToggleTheme from '../../assets/styled-components/themes/ToggleTheme';
import { getBasicGridData } from '@mui/x-data-grid-generator';
import { useTheme } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';

import NotificationsMenu from './NotificationsMenu';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useState, useEffect } from 'react';
import Vendordashboard from '../../pages/vendordashboard/Vendordashboard';
import { setIsEdit } from '../../redux/actions/dashboardActions';
import axios from 'axios';
import { FemsGraph, ifacSecurityURL } from '../../utility/apiURLS';
import { updateOutsourceDetails, updateWorkOrderStatus } from '../../redux/actions/workOrderActionTypes';
import { mandatoryFields } from '../../redux/actions/assetActions';
import notificationRepository from '../../api/repositories/notificationRepository';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import { clearRepairTrackerForVendor, clearWebForm } from '../../redux/actions/vendor/webFormActions';
import { scmClearRepairTrackerForVendor, scmClearWebForm } from '../../redux/actions/vendor/scmWebFormActions';
import { routineInspectionClearRepairTrackerForVendor, routineInspectionClearWebForm } from '../../redux/actions/vendor/routineInspectionWebFormActions';
const pages = ['Products', 'Pricing', 'Blog'];
const settings = ['Profile', 'Logout'];


function Header({ }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [anchorElNotification, setAnchorElNotification] = React.useState(null);
    const [anchorElSetting, setAnchorElSetting] = React.useState(null);

    const headerName = useSelector(state => state.authendicationReducer.headerName);
    const [header, setHeader] = useState('');
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
    const vendor = localStorage.getItem('UserName');
    const dispatch = useDispatch();
    const isEdit = useSelector(state => state.dashboard.isEdit);
    let userID = getuserId();  // Fetch roleName once and trim spaces
    let value = null;

    const [departmentData, setDepartmentData] = useState({ departmentName: '', departmentRole: '' });
    const roleName = localStorage.getItem("roleName");

    const [open, setOpen] = useState(false);
    const [emailuser, setEmail] = useState(null); // or '' if you want a string
    const [inputEmail, setInputEmail] = useState(emailuser);
    const [error, setError] = useState('');

    const handleEditDialogOpen = () => {
        setInputEmail(emailuser); // Reset input to current email
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setError('');
    };



    const handleSave = () => {
        // Simple email validation regex
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(inputEmail)) {
            setError('Please enter a valid email address.');
        } else {

            setEmail(inputEmail);
            UpdateHandleEmail();
            setOpen(false);
            setError('');
        }
    };

    useEffect(() => {
        fetchRoleName();
        fetchUserEmailid();
    }, []);

    const UpdateHandleEmail = async () => {
        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const user = getuserId("UserId");

            const exportUrl = `${ifacSecurityURL}/api/UpdateEmail/${user}/${inputEmail}`;
            const exportResponse = await axios.put(exportUrl, config);

            if (exportResponse.data && exportResponse.data.length > 0) {
                setDepartmentData(exportResponse.data); // Save the entire response array
            }
        } catch (error) {
            console.log("Error fetching user departments:", error);
        }
    };

    const fetchRoleName = async () => {
        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const user = getuserId("UserId");
            const facilityid = localStorage.getItem("facilityId");

            const exportUrl = `${FemsGraph}/api/UserLocationCode/GetUserdepartmentRolename/${user}/${facilityid}/${token}`;
            const exportResponse = await axios.get(exportUrl, config);

            if (exportResponse.data && exportResponse.data.length > 0) {
                setDepartmentData(exportResponse.data); // Save the entire response array
            }
        } catch (error) {
            console.log("Error fetching user departments:", error);
        }
    };

    const fetchUserEmailid = async () => {
        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const user = getuserId("UserId");
            const exportUrl = `${ifacSecurityURL}/api/GraphUserdetails/GetUserList/${user}`;
            const exportResponse = await axios.get(exportUrl, config);

            if (exportResponse.data && exportResponse.data.length > 0) {
                // If you want just one email (e.g. first one)
                const email = exportResponse.data[0].email;
                setEmail(email); // Just a single string
            }
        } catch (error) {
            console.log("Error fetching user departments:", error);
        }
    };


    useEffect(() => {
        if (vendor === "ifacvendor") {
            setHeader("Vendor Dashboard");
        } else {
            setHeader(headerName);
        }
    }, [vendor, headerName]);


    const handleLogout = async () => {

        removeAuthToken('id_token');
        removeFCMToken('fcmToken');
        await notificationRepository?.getFcmToken(userID, value);
        removeUserLoginStatus('user_login_status');
        dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
        dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: "", percentage: 0 }))
        dispatch({ type: "SERVICE&CATEGORY_TYPE", payload: {} });
        dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
        dispatch(routineInspectionClearWebForm("ROUTINEINSPECTION_CLEAR_WEB_FORM", {}));
        dispatch(clearWebForm("CLEAR_WEB_FORM", {}));
        dispatch(scmClearWebForm("SCM_CLEAR_WEB_FORM", {}));
               
            
        
        // dispatch(clearRepairTrackerForVendor("CLEAR_REPAIR_TRACKER_FOR_VENDOR", []));
        // dispatch(scmClearRepairTrackerForVendor("SCM_CLEAR_REPAIR_TRACKER_FOR_VENDOR", []));
        // dispatch(routineInspectionClearRepairTrackerForVendor("ROUTINEINSPECTION_CLEAR_REPAIR_TRACKER_FOR_VENDOR", []));
                
        
        navigate("/");
    };
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleOpenNotificationMenu = (event) => {
        setAnchorElNotification(event.currentTarget);
    };
    const handleCloseNotificationMenu = () => {
        setAnchorElNotification(null);
    };

    const handleOpenSettingMenu = (event) => {
        setAnchorElSetting(event.currentTarget);
    };
    const handleCloseSettingMenu = () => {
        setAnchorElSetting(null);
    };

    const handleCloseProfileModal = () => {
        setIsProfileModalOpen(false);
    };



    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleEditDashboard = () => {
        handleCloseSettingMenu()
        dispatch(setIsEdit('SET_IS_EDIT', true))
    }
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const handleProfileClick = () => {
        // Check if roleName in localStorage is "Userdept"

        setIsProfileModalOpen(true);

        handleCloseUserMenu();
    };

    const handlelocationchange = () => {
        navigate("/welcome");
    }
    // Styled component for curved shape
    const { color } = useSelector((state) => state.theme);
    const StyledCurvedBox = styled(Box)(({ theme, setCurveBg: { color } }) => {
        // const bg = `url(${lightmodeCurveBg})`;
        const setBg = (color) => {
            switch (color) {
                case 'default':
                    return `url(${lightmodeCurveBg})`;
                case 'blue':
                    return `url(${blueBg})`;
                case 'green':
                    return `url(${greenBg})`;
                case 'dark':
                    return `url(${darkBg})`;
                default:
                    return `url(${lightmodeCurveBg})`;
            }
        };
        const bg = setBg(color);
        return {
            backgroundColor: theme.palette.background.default,
            alignSelf: 'end',
            borderTopLeftRadius: '20px',
            borderTopRightRadius: '40px',
            position: 'relative',
            marginTop: '16px',
            minHeight: '36px',
            padding: '12px',
            '&::before': {
                content: `''`,
                position: 'absolute',
                left: '100%',
                bottom: '0',
                width: '30px',
                height: '50px',
                backgroundImage: bg,
                // ((mode, color) => {
                //     switch (color) {
                //         case 'default':
                //             return `url(${lightmodeCurveBg})`
                //         case 'blue':
                //             return `url(${lightmodeCurveBg})`
                //         default:
                //             return `url(${lightmodeCurveBg})`
                //     }
                // }),

                //  theme.palette.mode === 'light' ? `url(${lightmodeCurveBg})` : undefined, //Need to add for darkmode
                backgroundPosition: 'center',
            }
        }
    });

    return (
        <AppBar position="static" sx={{ width: '100%', padding: '0 24px 0 0', zIndex: 1500, boxShadow: 'none', position: 'sticky', top: 0, borderRadius: 0, backgroundImage: 'none', bgcolor: 'primary.main' }}>
            <Toolbar disableGutters sx={{ justifyContent: { md: 'space-between' } }}>
                {/* Curverd Box */}

                <StyledCurvedBox display={{ xs: 'none', sm: 'flex' }} alignItems={'center'} minWidth={{ xs: '40%', lg: '340px' }} minHeight={{ xs: '40px', sm: '60px' }} setCurveBg={{ color }}>
                    <Typography m={0} variant='title1' color={'text.primary'}>
                        {vendor === "ifacvendor" ? header : headerName}
                    </Typography>
                </StyledCurvedBox>


                {/* Responsive Burger Menu */}
                <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'none' } }}>
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleOpenNavMenu}
                        color="inherit"
                    >
                        <MenuIcon />
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorElNav}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        open={Boolean(anchorElNav)}
                        onClose={handleCloseNavMenu}
                        sx={{
                            display: { xs: 'block', md: 'none' },
                        }}
                    >
                        {pages.map((page) => (
                            <MenuItem key={page} onClick={handleCloseNavMenu}>
                                <Typography textAlign="center">{page}</Typography>
                            </MenuItem>
                        ))}
                    </Menu>
                </Box>
                <AdbIcon sx={{ display: { xs: 'none', md: 'none' }, mr: 1 }} />
                <Typography
                    variant="h5"
                    noWrap
                    component="a"
                    href="#app-bar-with-responsive-menu"
                    sx={{
                        mr: 2,
                        display: { xs: 'none', md: 'none' },
                        flexGrow: 1,
                        fontFamily: 'monospace',
                        fontWeight: 700,
                        letterSpacing: '.3rem',
                        color: 'inherit',
                        textDecoration: 'none',
                    }}
                >
                    LOGO
                </Typography>
                {/* -------------- */}
                {/* nav menu items */}
                <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'flex' }, justifyContent: { md: 'end' }, alignItems: { xs: 'center' }, gap: { md: 2 }, paddingInline: { xs: 2 }, marginLeft: { xs: 'auto' } }}>
                    <Box onClick={handlelocationchange} sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <Anchor sx={{ color: '#fff', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 1, paddingRight: 2, borderRight: '1px solid #FFF', cursor: 'pointer' }}><LocationOnIcon />{localStorage.getItem('FacilityName')}</Anchor>
                    </Box>
                    {/* <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <ToggleMode />
                    </Box> */}
                    {/* <Box>
                        <Box >
                            <IconButton onClick={handleOpenNotificationMenu} sx={{ p: 0 }}>
                                <NotificationsNoneIcon sx={{ color: '#FFF' }} />
                            </IconButton>
                            <Menu
                                sx={{ mt: '25px', zIndex: 1650 }}
                                id="notification"
                                keepMounted
                                anchorEl={anchorElNotification}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElNotification)}
                                onClose={handleCloseNotificationMenu}
                            >
                                <MenuItem onClick={handleCloseNotificationMenu}>
                                    <Typography textAlign="center">Notification 1</Typography>
                                </MenuItem>
                                <MenuItem onClick={handleCloseNotificationMenu}>
                                    <Typography textAlign="center">Notification 2</Typography>
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Box> */}
                    <NotificationsMenu />
                    {/* Setting Menu */}
                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <Box >
                            <IconButton onClick={handleOpenSettingMenu} sx={{ p: 0 }}>
                                <SettingsIcon sx={{ color: '#FFF' }} />
                            </IconButton>
                            <Menu
                                disableScrollLock={true}
                                sx={{ mt: '30px', zIndex: 1650 }}
                                id="notification"
                                anchorEl={anchorElSetting}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElSetting)}
                                onClose={handleCloseSettingMenu}
                            >
                                {/* handleCloseSettingMenu */}
                                <Paper sx={{ minWidth: 150 }}>
                                    <MenuItem onClick={handleEditDashboard} >Edit Dashboard</MenuItem>
                                    <Divider disableGutters />
                                    <ToggleTheme />
                                </Paper>
                            </Menu>
                        </Box>
                    </Box>
                </Box>
                {/* User Menu */}
                <Box sx={{ flexGrow: 0, display: 'inline-flex', alignItems: 'center', gap: 1.5 }}>
                    <CustomTooltip title="User">
                        <IconButton onClick={handleOpenUserMenu} sx={{
                            p: 1, backgroundColor: '#F0EDF2',
                            '&:hover': { backgroundColor: '#F0EDF2' }
                        }}>
                            <PersonOutlineIcon sx={{ color: '#110C14' }} />
                        </IconButton>
                    </CustomTooltip>
                    <Menu
                        sx={{ mt: '45px' }}
                        id="menu-appbar"
                        anchorEl={anchorElUser}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                    >
                        {settings.map((setting) => (
                            <MenuItem
                                key={setting}
                                onClick={() => {
                                    if (setting === 'Logout') handleLogout();
                                    else if (setting === 'Profile') handleProfileClick();
                                    else handleCloseUserMenu();
                                }}
                            >
                                <Typography textAlign="center">{setting}</Typography>
                            </MenuItem>
                        ))}
                    </Menu>
                    <Typography sx={{ color: '#FFF' }} component={'span'}>{localStorage.getItem('UserName')}</Typography>
                    {/* <Typography sx={{ color: '#FFF' }} component={'span'}>
            {localStorage.getItem('UserName')}
        </Typography> */}

                    {/* Profile Modal */}
                    <Modal
                        open={isProfileModalOpen}
                        onClose={(event, reason) => {
                            if (reason === "backdropClick") {
                                return; // Prevent closing on backdrop click
                            }
                            handleCloseProfileModal(); // Call the close function for other reasons
                        }}
                        aria-labelledby="profile-modal-title"
                        aria-describedby="profile-modal-description"

                    >
                        <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 'auto', // Adjust width to make the modal larger

                            bgcolor: 'background.paper',
                            p: 4,
                            boxShadow: 24,
                            borderRadius: 2
                        }}>
                            <IconButton
                                onClick={handleCloseProfileModal}
                                sx={{
                                    position: 'absolute',
                                    top: 8,
                                    right: 8,
                                    color: 'grey.500'
                                }}
                            >
                                <CloseIcon />
                            </IconButton>

                            <Typography id="profile-modal-title" variant="h6" component="h2">
                                <strong>Profile Details</strong>
                            </Typography>

                            <Typography id="profile-modal-description" sx={{ mt: 2 }}>
                                <strong>User Name:</strong> &nbsp;&nbsp;{localStorage.getItem('UserName')}
                            </Typography>


                            <Typography id="profile-modal-description" sx={{ mt: 2 }}>
                                <strong>   Role Name: </strong> &nbsp;&nbsp;{localStorage.getItem('roleName')}
                            </Typography>


                            {roleName === "DeptUser" && departmentData && departmentData.length > 0 && (
                                <>
                                    <Typography id="profile-modal-description" sx={{ mt: 2 }}>
                                        <strong>Dept Code:</strong> &nbsp;&nbsp;
                                        {departmentData.map(department => department.departmentName.trim()).join(", ")}
                                    </Typography>

                                    <Typography id="profile-modal-description" sx={{ mt: 2 }}>
                                        <strong>Dept Description:</strong> &nbsp;&nbsp;
                                        {departmentData.map(department => department.departmentRole.trim()).join(", ")}
                                    </Typography>
                                </>
                            )}

                            <Typography id="profile-modal-description" sx={{ mt: 2 }}>
                                <strong>Email:</strong>&nbsp;&nbsp; {emailuser}&nbsp;&nbsp;
                                <Button onClick={handleEditDialogOpen}>
                                    <ModeEditOutlinedIcon sx={{ cursor: 'pointer' }} />
                                </Button>
                            </Typography>



                        </Box>
                    </Modal>
                </Box>

            </Toolbar>
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") {
                        return; // Prevent closing on backdrop click
                    }
                    handleClose(); // Call the close function for other reasons
                }}
                // onClose={handleClose}
                PaperProps={{
                    sx: {
                        position: 'absolute',
                        top: '45%',
                        left: '48%',
                        transform: 'translate(-50%, -50%)',
                        width: 460,
                        height: 'auto',
                        bgcolor: 'background.paper',
                        p: 4,
                        boxShadow: 24,
                        borderRadius: 2
                    }
                }}
            >
                <DialogTitle>Edit Email</DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
                    <TextField
                        label="Email"
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        type="email"
                        placeholder="Enter your email"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ maxLength: 50 }}
                        value={inputEmail || ''}
                        onChange={(e) => {
                            setInputEmail(e.target.value);
                            if (error) setError('');
                        }}
                        error={Boolean(error)}
                        helperText={error}
                        autoFocus
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button
                            variant="contained"
                            onClick={handleSave}
                            disabled={
                                inputEmail?.trim() === '' || inputEmail === emailuser
                            }
                        >
                            Save
                        </Button>
                    </Box>
                </DialogContent>

            </Dialog>
        </AppBar >
    );
}
export default Header;